// extracted by mini-css-extract-plugin
export default {"loading":"tile-shortcut_loading__L-aqo","tile-shortcut":"tile-shortcut_tile-shortcut__T9+0u","col":"tile-shortcut_col__uUL9h","icon":"tile-shortcut_icon__roUbs"};